var jade = require("/app/app/assets/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<a ng-hide=\"session.human\" ng-click=\"login()\" href=\"\">Sign in</a><a ng-show=\"session.human\" ng-click=\"logout()\" href=\"\" title=\"{{session.human.full_name}} · {{session.human.email}}\">Sign out</a>");;return buf.join("");
}


/*****************
 ** WEBPACK FOOTER
 ** ./javascripts/common/directives/login-link.jade
 ** module id = 788
 ** module chunks = 0 1 3 4 5 6
 **/